import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';
const TOKEN_KEY = 'customer_token';

export const getCustomerToken = () => localStorage.getItem(TOKEN_KEY);
export const setCustomerToken = (token) => localStorage.setItem(TOKEN_KEY, token);
export const clearCustomerToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
    const t = getCustomerToken();
    return t ? { Authorization: `Bearer ${t}` } : {};
};

export const requestMagicLink = (email) =>
    axios.post(`${API}/customer/request-magic-link`, { email });

export const exchangeMagicToken = (token) =>
    axios.post(`${API}/customer/exchange-token`, { token });

export const fetchCustomerMe = () =>
    axios.get(`${API}/customer/me`, { headers: authHeaders() });

export const transferCertificate = ({ sale_id, new_name, new_email, new_phone }) =>
    axios.post(`${API}/customer/transfer`,
        { sale_id, new_name, new_email, new_phone },
        { headers: authHeaders() }
    );
